/* eslint-disable import/no-anonymous-default-export */

const EDrumStatus = {
  PENDING: { code: 'PENDING', description: 'Pendente', label: 'Pendente', color: 'gold' },
  PROCESSED: { code: 'PROCESSED', description: 'Processado', label: 'Processado', color: 'green' },
};

EDrumStatus.getByCode = (code) => Object.values(EDrumStatus).find(t => t && t.code === code) || null;

export default EDrumStatus;
